/* eslint-disable @typescript-eslint/camelcase */
import Apis from 'apis';

export const api = Apis({});

interface QueryProps {
  limit?: number | string;
  offset?: number | string;
  search?: string;
}

export default {
  getDataDashboardCompany: (companyUuid: string) =>
    `/dashboard/${companyUuid}/?only_summary=true`,
  getDataDashboardCompanyPartner: (
    companyUuid: string,
    partnerUuid: string,
    intervalTime?: string
  ) =>
    `/dashboard/${companyUuid}/partner/${partnerUuid}/?only_summary=true&period=${intervalTime ||
      '30d'}`,
  getPartnerDataGraph: (
    companyUuid: string,
    partnerUuid: string,
    intervalTime: string,
    start_date?: string,
    end_date?: string
  ) =>
    `/dashboard/${companyUuid}/partner/${partnerUuid}/environments-graph/?end-date=${end_date}&period=${intervalTime}&start-date=${start_date}`,
  getPartnerEnvironmentsCostGraph: (
    companyUuid: string,
    partnerUuid: string,
    intervalTime: string
  ) =>
    `/dashboard/${companyUuid}/partner/${partnerUuid}/environments-cost/?period=${intervalTime}`,
};
